<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            :append-to-body="true"
            width="1000px"
            :center="true"
            top="50px"
            :fullscreen="true"
            :close-on-click-modal="false"
            :show-close="false"
            :before-close="() => closeDialog()"
            id="Prize10Dialog"
        >
            <div class="lottery-container">
                <div 
                    v-for="(card, index) in cards" 
                    :key="index" 
                    class="card-wrapper"
                    :class="{ 'card-visible': card.visible }"
                >
                    <div 
                        class="card" 
                        :class="{ flipped: card.flipped }"
                    >
                        <div class="front">1</div>
                        <div class="back">
                            <img :src="card.url" style="position:absolute;text-align: center;top:20px;width:80%;border-radius: 10px;">
                        <span style="position:absolute;text-align: center;top:140px;font-family: HarmonyOS_Sans_Black;font-weight: bold;font-size: 20px;color: #EA0000;width:90%;">{{ card.content }}</span>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div style="text-align: center;">
                <el-button v-if="!isPlaying" plain @click="get_award">再来一次</el-button>
                <el-button v-if="!isPlaying" plain @click="closeDialog()">告辞告辞</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { KeyTenRequest } from '@/network/user.js'

export default {
    name:'',
    data(){
        return {
            cards: [
                { visible: false, flipped: false, content: '1等奖' },
                { visible: false, flipped: false, content: '2等奖' },
                { visible: false, flipped: false, content: '3等奖' },
                { visible: false, flipped: false, content: '4等奖' },
                { visible: false, flipped: false, content: '5等奖' },
                { visible: false, flipped: false, content: '6等奖' },
                { visible: false, flipped: false, content: '7等奖' },
                { visible: false, flipped: false, content: '8等奖' },
                { visible: false, flipped: false, content: '9等奖' },
                { visible: false, flipped: false, content: '10等奖' }
            ],
            isPlaying: false,
            currentIndex: 0,
            showDelay: 300,    // 显示延迟（毫秒）
            flipDelay: 300     // 翻牌延迟（毫秒）
        }
    },
    computed:{},
    methods:{
        closeDialog() {
            if (this.isPlaying) {
                this.$message.error('请等待抽奖完成后再关闭')
                return
            }
            this.isPlaying = false
            this.cards.forEach(card => {
                card.visible = false;
                card.flipped = false;
            });
            this.$emit('closeDialog')
        },
        startSequence() {
            if (this.isPlaying) return;
            this.isPlaying = true;
            this.currentIndex = 0;
            
            // 重置所有卡片状态
            this.cards.forEach(card => {
                card.visible = false;
                card.flipped = false;
            });
            
            // 开始顺序展示
            this.showNextCard();
        },

        showNextCard() {
            if (this.currentIndex >= this.cards.length) {
                this.isPlaying = false;
                return;
            }
            
            const currentCard = this.cards[this.currentIndex];
            
            // 显示当前卡片
            this.$set(currentCard, 'visible', true);
            
            // 延迟后翻牌
            setTimeout(() => {
                this.$set(currentCard, 'flipped', true);
                
                // 翻牌完成后，处理下一张
                this.currentIndex++;
                setTimeout(() => this.showNextCard(), this.showDelay);
            }, this.flipDelay);
        },
        get_award() {
            KeyTenRequest()
                .then((s) => {
                        if (s.status === 0) {
                            this.cards = s.result
                            this.$emit('RefreshBindKey')
                            this.startSequence()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
    },
    filters:{},
    props:{
        dialogVisible: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    created(){},
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>
<style>
#Prize10Dialog>.el-dialog {
    background-color:transparent;
}
</style>
<style  lang="less" scoped>
.lottery-container {
    display: grid;
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    column-gap: 20px;  /* 只控制水平间距 */
    row-gap: 20px;    /* 只控制垂直间距 */
    padding: 20px;
    width: fit-content; /* 容器宽度适应内容 */
    max-width: 100%;    /* 最大不超过父容器 */
    margin: 0 auto;     /* 居中显示 */
}

.card-wrapper {
    opacity: 0;  /* 初始隐藏 */
    transform: scale(0.8);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.card-visible {
    opacity: 1;  /* 显示时的样式 */
    transform: scale(1);
}

.card {
    position: relative;
    width: 167px;
    height: 234px;
    margin: 0 1rem;
    transition: 1s;
    cursor: pointer;
    border-radius: 10px;
}

.front, .back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.front {
    background: url(../../assets/img/choujiangka.png) center center no-repeat;
    background-size: cover;
    background-position: center;
    transform: rotateY(0deg);
}

.back {
    position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                background: url(../../assets/img/jiangpinbiankuang.png) center center no-repeat;
                background-size: 100% 100%; // 用contain会出现图片大小变化div外层不变
                transform: rotateY(180deg);
                font-size: 1rem;
                color: #f1c40f;
                border-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
}

.flipped .front { transform: rotateY(180deg); }
.flipped .back { transform: rotateY(0deg); }

button:hover { background: #166088; }
button:disabled { background: #ccc; cursor: not-allowed; }

/* 超大屏幕 */
@media (min-width: 1200px) {
    .lottery-container {
        grid-template-columns: repeat(5, minmax(140px, 1fr));
        border-color: purple;
    }
}

/* 中等屏幕 */
@media (max-width: 1024px) {
    .lottery-container {
        grid-template-columns: repeat(4, minmax(120px, 1fr));
        border-color: blue; /* 调试用：确认是否触发 */
    }
}

/* 小屏幕 */
@media (max-width: 800px) {
    .lottery-container {
        grid-template-columns: repeat(3, minmax(120px, 1fr));
        border-color: green;
    }
}

/* 迷你屏幕 */
@media (max-width: 600px) {
    .lottery-container {
        grid-template-columns: repeat(2, minmax(120px, 1fr));
        border-color: green;
    }
}
</style>